export default "__VITE_ASSET__8iNd8zVJ__"